<a class="cc-icon cc-icon-close close-modal" aria-label="Close" (click)="onCloseModal()"></a>

<!-- Notification -->
<div class="loaded-container w-100">
  <header>
    <h1 class="h1" i18n>Your Sitemate Link has been successfully {{ taskCreationMode }}!</h1>
  </header>
  <p class="mb-4" *ngIf="taskType === taskTypes.FormSingle" i18n>
    Once someone clicks the link, they will be able to submit one form per template via the Sitemate app.
  </p>
  <p class="mb-4" *ngIf="taskType === taskTypes.FormRecurring" i18n>
    Once someone clicks the link, they will be able to submit <strong>multiple forms</strong> per template via
    the Sitemate app.
  </p>
  <div class="section-container">
    <section class="distribute-link" i18n>
      <header>
        <a
          href="https://intercom.help/dashpivot/en/articles/5252542-distributing-template-links"
          target="_blank"
          class="btn btn-sm cc-btn-subtle-gray"
        >
          <i class="mr-1 cc-icon cc-icon-question"></i><span>Watch demo</span>
        </a>
      </header>
      <main>
        <p>Distribute this link via email or SMS to the relevant people to click</p>
        <span class="copy-input">{{ taskDefinition.urlLabel }}</span
        ><span
          [cdkCopyToClipboard]="taskDefinition.url"
          *ngIf="!isLinkCopied"
          (click)="onLinkCopied()"
          class="cc-btn-subtle-blue-helper copy-link"
        >
          <i class="cc-icon cc-icon-link-chain"></i>
          Copy </span
        ><span *ngIf="isLinkCopied" class="copied-link">
          <i class="cc-icon cc-icon-check"></i>
          Copied
        </span>
      </main>
    </section>
    <section class="download-pdf" i18n>
      <header>
        <a
          href="https://intercom.help/dashpivot/en/articles/5252535-using-qr-code-posters-for-sitemate-forms"
          target="_blank"
          class="btn btn-sm cc-btn-subtle-gray"
        >
          <i class="mr-1 cc-icon cc-icon-question"></i><span>Watch demo</span>
        </a>
      </header>
      <main>
        <p>Download and print a site poster with the link URL</p>
        <button class="btn-download btn cc-btn-subtle-blue-helper" (click)="onQrCodePosterDownload()">
          <i class="cc-icon cc-icon-download-pdf"></i>Download Poster
        </button>
      </main>
    </section>
  </div>
  <footer>
    <p class="mt-4 mb-2" i18n>Forms submitted via the Sitemate app will appear in your Dashpivot account.</p>
    <button
      class="mt-1 btn btn-md btn-extra-padding action-close cc-btn-subtle-blue-helper"
      (click)="onCloseModal()"
      i18n
    >
      Done
    </button>
  </footer>
</div>
